"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
function CategoryFilterBar() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="95858" className="flex flex-wrap items-center justify-center gap-4">
        {[...Array(5)].map((_, i) => <div key={i} data-index={i} className="h-10 w-32 animate-pulse rounded-full bg-primary/10" />)}
      </div>;
  }
  if (error || terms.length === 0) {
    return null;
  }
  return <div className="flex flex-wrap items-center justify-center gap-4">
      {terms.map((term, i) => <Link key={term.id} data-index={i} to={term.link || "#"} className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-border/50 bg-card/40 px-6 py-2 font-default text-xs font-bold uppercase tracking-widest text-foreground transition-all duration-300 backdrop-blur-md hover:border-primary hover:bg-primary hover:text-primary-foreground hover:shadow-[0_0_20px_rgba(0,255,255,0.3)]">
          {term.name}
        </Link>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 8,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function CuratedDigitalCollections() {
  return <section id="top-ai-tools-2026" className="bg-background px-4 py-8 md:px-8 lg:px-16 text-foreground">
      <div className="mx-auto max-w-7xl">
        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <CategoryFilterBar />
        </EcommerceTermsProvider>
      </div>
    </section>;
}